<template>
    <div>
        <div class="globalHeader">
            <img v-if="!closeFlag" src="../assets/images/rightcorner.png" alt="" @click='back'>
            <van-icon v-else @click='back' name="cross" />
            <p>{{title}}</p>
            <p></p>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        title:{
            type:String
        }
    },
    data(){
        return {
          closeFlag: false
        }
    },
    mounted(){
      console.log('aaaa',this.$route);
      if(this.$route.path == '/'){
        this.closeFlag = true;
      }else{
        this.closeFlag = false;
      }
    },
    methods: {
        back(){

          if(this.closeFlag){
            this.$router.replace({
              path: '/home'
            })
          }else{
            this.$router.go(-1);
          }
        }
    },

}
</script>
<style lang="less" scoped>
.globalHeader{
    width: 100%;
    height:40px;
    display: flex;
    justify-content:space-between;
    align-items:center;
    padding: 0 10px;
    box-sizing: border-box;
    position:fixed;
    left: 0;
    top: 0;
    z-index: 10;
    //background-image: linear-gradient(90deg, #FF9F22, #FFB600);
    img{
      width:19px;
      height:22px;
      transform:rotate(180deg)
    }
    p{
      font-size: 0.9rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/globalHeader.vue